varying vec3 vWPos;
//varying vec3 vWorldNormal;
varying vec2 vUV; 
//varying float vHeight; 
//uniform sampler2D uHeightmap; 



void main() {
  vUV = uv; 

  //vHeight = texture2D(uHeightmap, uv).x * 100.0;
  //vec3 pos = position;
  //pos.y += vHeight;

  //vWorldNormal = (modelMatrix * vec4(normal, 0.0)).xyz;
  //vWorldNormal = -normalize(vec3(-vWorldNormal.x, vWorldNormal.yz));

  vec4 modelViewPosition = modelViewMatrix * vec4(position, 1.0);
  gl_Position = projectionMatrix * modelViewPosition; 
  vWPos = (modelMatrix * vec4(position, 1.0)).xyz;

}